var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.asDialog)?_c('vue-tree-navigation',{staticClass:"treeNavClass",attrs:{"items":_vm.items}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }